import { Product } from '@core/models/piramide/Product';

export class Memoria extends Product {
  $caracteristicas: {
    activo: number;
    cantidad?: number;
    capacidad: number;
    disipacion_alta: number;
    disipador: number;
    fecha_update?: string;
    id_producto: number;
    latencia_cl: number;
    marca: string;
    slot: number;
    sodimm: number;
    tipo: string;
    velocidad: number;
    voltaje: number;
    w: number;
  };
  public constructor(product: Product) {
    super(product);

    if (product.id_subcategoria !== 15 && product.id_subcategoria !== 47) {
      throw 'esto no es una memoria';
    }
  }
}
